import { defineStore } from 'pinia'

export const useUploadsStore = defineStore('uploads', {
    state: () => ({
        r: null, // this will house our resumable.js object
        files: [],
    }),

    actions: {
        addFile(file) {
            this.files.push(file)
            this.r.upload()
        },
        updateFile(file) {
            let index = this.files.findIndex(f => f.uniqueIdentifier === file.uniqueIdentifier)
            this.files[index] = file
        },
		removeFile(file) {
			this.files = this.files.filter(f => f.uniqueIdentifier !== file.uniqueIdentifier)
		},
		clearFiles() {
			this.files = []
		}
    },
})
